export default __webpack_public_path__ + "static/media/Arrow 2.c21db314.svg";